import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getDefaultCalendarHolidays(planzone)
        .then((defaultCalendarHolidays) => ({
          planzone,
          defaultCalendarHolidays,
        }))
        .catch(() => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
